export const documentData = [
	{
		id: "remark",
		label: "Remark",
		placeholder: "",
		type: "textarea",
		helperText: "Any remark or additional information",
		validationType: "string",
		value: "",
		validations: [],
	},
	{
		id: "textNote",
		label: "",
		placeholder: "",
		type: "statictext",
		validationType: "string",
		// value: "* Please note: 1) All documents are mandatory to submit 2) Maximum 2mb file is allowed 3) only JPG, JPEG, PNG, PDF files are allowed",
		value: "* Please note: 1) All documents are mandatory to submit 2) Maximum 2mb file is allowed 3) only PDF files are allowed",
		validations: [],
		preview: false,
	},
	{
		id: "photo",
		label: "Photo (passport size) *",
		placeholder: "please upload passport size photograph",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["photo is required"],
			},
			// {
			// 	type: "test",
			// 	params: [
			// 		"filesize",
			// 		"file is too large",
			// 		(values) => {
			// 			console.log(values, values.type, values.size);
			// 			return values && values.size <= FILE_SIZE;
			// 		},
			// 	],
			// },
			// {
			// 	type: "test",
			// 	params: [
			// 		"fileformat",
			// 		"Unsupported Format",
			// 		(value) => value && SUPPORTED_FORMATS.includes(value.type),
			// 	],
			// },
		],
	},
	{
		id: "idCard",
		label: "College/School ID card *",
		placeholder: "School Calendar, ID card whatever is available",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["ID card is required"],
			},
		],
	},
	{
		id: "feeReciept",
		label: "Current Academic Year's Fee Reciept *",
		placeholder: "",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Fee reciept is required"],
			},
		],
	},
	{
		id: "incomeProof",
		label: "Income Proof (complete copy of the Income Tax Return (ITR) or Salary Certificate or Salary Slip) *",
		placeholder: "ITR, Salary Slip",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Income proof is required"],
			},
		],
	},
	{
		id: "electricityBill1",
		label: "Electricity bill of June 2026 *",
		placeholder: "Electricity bill of June 2026.",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Electricity bill as proof is required"],
			},
		],
	},
	{
		id: "electricityBill2",
		label: "Electricity bill of May 2026 *",
		placeholder: "Electricity bill of May 2026",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Electricity bill as proof is required"],
			},
		],
	},
	{
		id: "electricityBill3",
		label: "Electricity bill of April 2026 *",
		placeholder: "Electricity bill of April 2026.",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Electricity bill as proof is required"],
			},
		],
	},
	{
		id: "rationCard",
		label: "Ration Card *",
		placeholder: "Provide front and back of the card",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Ration Card as proof is required"],
			},
		],
	},
	{
		id: "markSheetCopyProof",
		label: "Mark Sheet *",
		placeholder: "Latest Marksheet / Last Year Marksheet",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Marksheet is required"],
			},
		],
		rules: {
			and: [
				{
					"!=": [
						{ var: "markSheetCopyCheck" },
						"Do not have latest marksheet",
					],
				},
			],
		},
		action: [{ type: "required" }],
	},
	{
		id: "markSheetCopyCheck",
		label: "Do not have latest marksheet (ચાલુ વર્ષની માર્કશીટ મળી નથી)",
		placeholder: "",
		type: "checkbox",
		helperText: "",
		validationType: "string",
		value: "",
		options: ["Do not have latest marksheet"],
		validations: [],
	},
	{
		id: "markSheetCopyCheckTextNote",
		label: "",
		placeholder: "",
		type: "statictext",
		validationType: "string",
		value: "Increases chance of application rejection, It would be applicant's responsiblilty to provide missing document as soon as document is available to SVGA's office",
		validations: [],
		preview: false,
		rules: {
			and: [
				{
					"==": [
						{ var: "markSheetCopyCheck" },
						"Do not have latest marksheet",
					],
				},
			],
		},
		action: [{ type: "required" }],
	},
	{
		id: "aadharCardProof",
		label: "Student's Aadhar Card Full copy need to be provided *",
		placeholder: "Student's Aadhar Card Full copy need to be provided",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Aadhar Card is required"],
			},
		],
	},
	{
		id: "additionalDocs1",
		label: "Additional Document 1 (Leave & Licence Agreement Copy (1,2, 3 & last page)",
		placeholder:
			"Any document that does not exist above and is an additional ask by SVGA",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
	},
	{
		id: "additionalDocs2",
		label: "Additional Document 2 (Rent / Maintenance receipt - if Shop or home on rent)",
		placeholder:
			"Any document that does not exist above and is an additional ask by SVGA",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
	},
];
